// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mplO0984ls_0yv {
  margin: var(--ds-space-0, 0px) var(--ds-space-150, 12px) var(--ds-space-100, 8px);
  padding: var(--ds-space-200, 16px) var(--ds-space-050, 4px);
  border-radius: var(--ds-border-radius-100, 3px);
  background-color: var(--ds-background-neutral, #091e420f);
  color: var(--ds-text-subtle, #44546f);
  text-align: center;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"searchingState": `mplO0984ls_0yv`
};
export default ___CSS_LOADER_EXPORT___;
